import React from 'react'

const MatchFollowingEquation = (data) => {
    return (
        <div>
            <table
                style={{
                    // width: "100%",
                    borderCollapse: "collapse",
                }}
            >
                <thead>
                    <tr>
                        <th
                            style={{
                                border:
                                    "1px solid black",
                                padding: "8px",
                            }}
                        >
                            Question
                        </th>
                        <th
                            style={{
                                border:
                                    "1px solid black",
                                padding: "8px",
                            }}
                        >
                            Answer
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {data?.data?.perfact_metch.map(
                        (item, index) => (
                            <tr key={index}>
                                <td
                                    style={{
                                        border:
                                            "1px solid black",
                                        padding: "8px",
                                    }}
                                >
                                    <div dangerouslySetInnerHTML={{ __html: item?.finalquestion }} />
                                </td>
                                <td
                                    style={{
                                        border:
                                            "1px solid black",
                                        padding: "8px",
                                    }}
                                >
                                    <div dangerouslySetInnerHTML={{ __html: item?.finalanswer }} />
                                </td>
                            </tr>
                        )
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default MatchFollowingEquation


export const DifferenceAnswer = (data) => {
    return (
        <div>
            <table
                style={{
                    // width: "100%",
                    borderCollapse: "collapse",
                }}
            >
                <tbody>
                    {data?.data?.perfact_metch.map(
                        (item, index) => (
                            <tr key={index}>
                                <td
                                    style={{
                                        border:
                                            "1px solid black",
                                        padding: "8px",
                                    }}
                                >
                                    <div dangerouslySetInnerHTML={{ __html: item?.finalquestion }} />
                                </td>
                                <td
                                    style={{
                                        border:
                                            "1px solid black",
                                        padding: "8px",
                                    }}
                                >
                                    <div dangerouslySetInnerHTML={{ __html: item?.finalanswer }} />
                                </td>
                            </tr>
                        )
                    )}
                </tbody>
            </table>
        </div>
    )
}